"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const parseMimetypes_1 = require("../utils/parseMimetypes");
const parsePlugins_1 = require("../utils/parsePlugins");
function default_1() {
    return __awaiter(this, void 0, void 0, function* () {
        let nav = window.navigator;
        return {
            vendor: nav.vendor || "",
            app: {
                codename: nav.appCodeName,
                name: nav.appName,
            },
            product: {
                name: nav.product,
                sub: nav.productSub
            },
            language: {
                current: nav.language,
                list: nav.languages
            },
            userAgent: nav.userAgent,
            plugins: (0, parsePlugins_1.default)(nav.plugins),
            capabilities: {
                contacts: 'contacts' in navigator && 'ContactsManager' in window,
                pdfViewer: nav.pdfViewerEnabled || false,
                cookies: nav.cookieEnabled || false
            },
            mimeTypes: (0, parseMimetypes_1.default)(nav.mimeTypes) || [],
            canvas: "",
            bars: {
                menubar: window.menubar.visible || false,
                personalbar: window.personalbar.visible || false,
                statusbar: window.statusbar.visible || false,
                toolbar: window.toolbar.visible || false
            },
            doNotTrack: nav.doNotTrack || "NC"
        };
    });
}
exports.default = default_1;
